const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMangenLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 567 567",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "right"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect8055-8-09",
    x: 481.872,
    y: 283.464,
    width: 28.344,
    height: 28.344,
    style: {
      fill: "#0a0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8055-28-2-9",
    x: 425.184,
    y: 198.433,
    width: 28.344,
    height: 28.344,
    style: {
      fill: "#2cd62c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8055-28-2-8",
    x: 453.528,
    y: 226.777,
    width: 28.344,
    height: 28.344,
    style: {
      fill: "#5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8055-28-2-7",
    x: 481.872,
    y: 255.12,
    width: 28.344,
    height: 28.344,
    style: {
      fill: "#5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8055-28-2-71",
    x: 396.84,
    y: 368.495,
    width: 28.344,
    height: 28.344,
    style: {
      fill: "#0a0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8055-28-2-1",
    x: 425.184,
    y: 340.152,
    width: 28.344,
    height: 28.344,
    style: {
      fill: "#0a0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8055-28-2-3",
    x: 453.528,
    y: 311.808,
    width: 28.344,
    height: 28.344,
    style: {
      fill: "#0a0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8055-28-2-2",
    x: 396.84,
    y: 170.089,
    width: 28.344,
    height: 28.344,
    style: {
      fill: "#2cd62c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "center"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect8055-28",
    x: 226.778,
    y: 311.808,
    width: 28.344,
    height: 28.344,
    style: {
      fill: "#0aa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8055-4",
    x: 198.434,
    y: 340.152,
    width: 28.344,
    height: 28.344,
    style: {
      fill: "#0aa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8055-28-5",
    x: 283.465,
    y: 255.12,
    width: 28.344,
    height: 28.344,
    style: {
      fill: "#0a0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8055-4-0",
    x: 255.122,
    y: 283.464,
    width: 28.344,
    height: 28.344,
    style: {
      fill: "#0aa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8055-28-2",
    x: 340.153,
    y: 198.433,
    width: 28.344,
    height: 28.344,
    style: {
      fill: "#0a0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8055-4-9",
    x: 311.809,
    y: 226.777,
    width: 28.344,
    height: 28.344,
    style: {
      fill: "#0a0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "left"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect8055",
    x: 141.747,
    y: 170.089,
    width: 28.344,
    height: 28.344,
    style: {
      fill: "#5ff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8055-9",
    x: 113.403,
    y: 198.433,
    width: 28.344,
    height: 28.344,
    style: {
      fill: "#5ff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8055-8",
    x: 85.059,
    y: 226.777,
    width: 28.344,
    height: 28.344,
    style: {
      fill: "#2bd5d5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8055-8-0",
    x: 56.715,
    y: 283.464,
    width: 28.344,
    height: 28.344,
    style: {
      fill: "#0aa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8055-7",
    x: 56.715,
    y: 255.12,
    width: 28.344,
    height: 28.344,
    style: {
      fill: "#2bd5d5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8055-14",
    x: 141.747,
    y: 368.495,
    width: 28.344,
    height: 28.344,
    style: {
      fill: "#0aa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8055-1",
    x: 113.403,
    y: 340.152,
    width: 28.344,
    height: 28.344,
    style: {
      fill: "#0aa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8055-2",
    x: 85.059,
    y: 311.808,
    width: 28.344,
    height: 28.344,
    style: {
      fill: "#0aa"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMangenLogo);
export default __webpack_public_path__ + "static/media/mangen_logo.fb744667acec3d98563808eaa8b1a99b.svg";
export { ForwardRef as ReactComponent };